import React from 'react';
import { Card, Grid2 as Grid, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  stats: { i18nKey: string; value: string | number }[];
}

export const StatsDashboard: React.FC<Props> = ({ stats }) => {
  const { t } = useTranslation();
  return (
    <Paper elevation={0} sx={{ pt: '12px', pb: '4px', px: '24px' }}>
      <Grid container columnSpacing="24px" rowSpacing="12px" justifyContent="center" alignItems="start">
        {stats.map(({ i18nKey, value }, i) => (
          <Grid size={4} key={i18nKey}>
            <Card
              elevation={0}
              sx={{
                p: '12px',
                width: '100%',
                height: '100%',
                ...(i % 3 === 0 && { justifyItems: 'end' }),
                ...(i % 3 === 1 && { justifyItems: 'center' }),
                ...(i % 3 === 2 && { justifyItems: 'start' }),
              }}
            >
              <Stack direction="column" textAlign="center" spacing="0px">
                <Typography fontSize="24px" color="secondary">
                  {value}
                </Typography>
                <Typography fontSize="14px" color="text.secondary">
                  {`${t(i18nKey)}`}
                </Typography>
              </Stack>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};
